var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoAccess = function SvgNoAccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#noAccess_svg__a)",
    d: "M36 11.52c-13.499 0-24.48 10.981-24.48 24.48 0 4.525 1.238 8.896 3.597 12.738l33.621-33.62A24.24 24.24 0 0 0 36 11.52m0 48.96c13.499 0 24.48-10.981 24.48-24.48 0-4.524-1.238-8.896-3.597-12.738l-33.621 33.62A24.24 24.24 0 0 0 36 60.48M36 0c19.852 0 36 16.148 36 36S55.852 72 36 72 0 55.852 0 36 16.148 0 36 0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "noAccess_svg__a",
    x1: 36,
    x2: 36,
    y1: 2.088,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })))));
};
export default SvgNoAccess;